import { imageFileType } from '#types/fileType';
import { getFileExtension } from './getFileExtension';

export const getIsImage = (url: string) => {
  const fileExtension = '.' + getFileExtension(url);

  return imageFileType.split(', ').includes(fileExtension);
};
